import { createRouter, createWebHistory } from 'vue-router';
import mobileRoutes from './mobileRoutes';
import webRoutes from './webRoutes';
const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes: webRoutes.concat(mobileRoutes),
});
router.beforeEach(() => {
    return true;
});
router.onError((error) => {
    if (/ChunkLoadError:.*failed./i.test(error.message) || error.name === 'ChunkLoadError') {
        window.location.reload();
    }
});
export default router;
